
export default {
  layout: 'default',
}
